export const initialState = {
  documentPartnerRelations: []
};

export const reducer = (state, action) => {
  switch (action.type) {
    case "OnInitState":
      return onInitState(state, action);
    case "OnPropertyChange":
      return onPropertyChange(state, action);
    case "OnPartnerLoaded":
      return onPartnerLoaded(state, action);
    case "BeforePartnerLoad":
      return beforePartnerLoad(state, action);
    case "OnPartnerLoadFailed":
      return onPartnerLoadFailed(state, action);
    case "OnExpandChange":
      return onExpandChange(state, action);
    case "OnDocumentPartnerRelationSaved":
      return onDocumentPartnerRelationSaved(state, action);
    case "OnPartnerRelationSaveFailed":
      return onPartnerRelationSaveFailed(state, action);
    case "BeforeSavingDocumentPartnerRelation":
      return beforeSavingDocumentPartnerRelation(state, action);
    case "OnAddNewDocumentPartnerRelation":
      return onAddNewDocumentPartnerRelation(state, action);

    default:
      return state;
  }
};

const onInitState = (state, action) => {
  const { documentPartnerRelations } = action;
  return {
    ...state,
    documentPartnerRelations: documentPartnerRelations.map(item => {
      return {
        ...item,
        directPartnerLoading: false,
        directPartnerLoaded: true,
        reversePartnerLoading: false,
        reversePartnerLoaded: true
      };
    })
  };
};

const onPropertyChange = (state, action) => {
  const { property, propertyValue, index } = action;
  return {
    ...state,
    documentPartnerRelations: Object.assign([...state.documentPartnerRelations], {
      [index]: {
        ...state.documentPartnerRelations[index],
        [property]: propertyValue,
        changed: true
      }
    })
  };
};

const onPartnerLoaded = (state, action) => {
  const { isDirectPartner, data, index } = action;
  if (isDirectPartner)
    return {
      ...state,
      documentPartnerRelations: Object.assign([...state.documentPartnerRelations], {
        [index]: {
          ...state.documentPartnerRelations[index],
          directPartnerId: data.partnerId,
          directPartnerName: data.partnerName,
          directPartnerLoading: false,
          directPartnerLoaded: true,
          changed: true
        }
      })
    };
  else
    return {
      ...state,
      documentPartnerRelations: Object.assign([...state.documentPartnerRelations], {
        [index]: {
          ...state.documentPartnerRelations[index],
          reversePartnerId: data.partnerId,
          reversePartnerName: data.partnerName,
          reversePartnerLoading: false,
          reversePartnerLoaded: true,
          changed: true
        }
      })
    };
};

const beforePartnerLoad = (state, action) => {
  const { isDirectPartner, index } = action;
  if (isDirectPartner)
    return {
      ...state,
      documentPartnerRelations: Object.assign([...state.documentPartnerRelations], {
        [index]: {
          ...state.documentPartnerRelations[index],
          directPartnerId: null,
          directPartnerName: "",
          directPartnerLoading: true,
          directPartnerLoaded: false,
          changed: true
        }
      })
    };
  else
    return {
      ...state,
      documentPartnerRelations: Object.assign([...state.documentPartnerRelations], {
        [index]: {
          ...state.documentPartnerRelations[index],
          reversePartnerId: null,
          reversePartnerName: "",
          reversePartnerLoading: true,
          reversePartnerLoaded: false,
          changed: true
        }
      })
    };
};

const onPartnerLoadFailed = (state, action) => {
  const { isDirectPartner, index } = action;
  if (isDirectPartner)
    return {
      ...state,
      documentPartnerRelations: Object.assign([...state.documentPartnerRelations], {
        [index]: {
          ...state.documentPartnerRelations[index],
          directPartnerLoading: false,
          directPartnerLoaded: false,
          directPartnerName: "",
          changed: true
        }
      })
    };
  else
    return {
      ...state,
      documentPartnerRelations: Object.assign([...state.documentPartnerRelations], {
        [index]: {
          ...state.documentPartnerRelations[index],
          reversePartnerLoading: false,
          reversePartnerLoaded: false,
          reversePartnerName: "",
          changed: true
        }
      })
    };
};

const onDocumentPartnerRelationSaved = (state, action) => {
  const { index, partnerRelationId } = action;
  return {
    ...state,
    documentPartnerRelations: Object.assign([...state.documentPartnerRelations], {
      [index]: {
        ...state.documentPartnerRelations[index],
        partnerRelationId: partnerRelationId,
        changed: false,
        saving: false
      }
    })
  };
};

const onPartnerRelationSaveFailed = (state, action) => {
  const { index } = action;
  return {
    ...state,
    documentPartnerRelations: Object.assign([...state.documentPartnerRelations], {
      [index]: {
        ...state.documentPartnerRelations[index],
        saving: false
      }
    })
  };
};

const beforeSavingDocumentPartnerRelation = (state, action) => {
  const { index } = action;
  return {
    ...state,
    documentPartnerRelations: Object.assign([...state.documentPartnerRelations], {
      [index]: {
        ...state.documentPartnerRelations[index],
        saving: true
      }
    })
  };
};

const onAddNewDocumentPartnerRelation = (state, action) => {
  const { documentId, siteId, userProfile } = action;
  const newPartnerRelation = {
    directPartnerUniqueID: "",
    reversePartnerUniqueID: "",
    partnerRelationId: null,
    documentId: documentId,
    siteId: siteId,
    relationStartDate: new Date().toISOString(),
    relationExpireDate: new Date().toISOString(),
    lastUpdateUserName: userProfile ? userProfile.name : "",
    lastUpdateDate: new Date().toISOString(),
    isActive: true,
    changed: true,
    isExpanded: true,
    directRelation: "",
    directPartnerName: "",
    directPartnerLoading: false,
    directPartnerLoaded: true,
    reverseRelation: "",
    reversePartnerName: "",
    reversePartnerLoading: false,
    reversePartnerLoaded: true
  };

  const documentPartnerRelations = Object.assign([...state.documentPartnerRelations]);
  documentPartnerRelations.unshift(newPartnerRelation);

  return {
    ...state,
    documentPartnerRelations: [...documentPartnerRelations]
  };
};

const onExpandChange = (state, action) => {
  const { index } = action;
  const isExpanded = state.documentPartnerRelations[index].isExpanded;
  return {
    ...state,
    documentPartnerRelations: Object.assign([...state.documentPartnerRelations], {
      [index]: {
        ...state.documentPartnerRelations[index],
        isExpanded: !isExpanded
      }
    })
  };
};
